import React, { useState, forwardRef } from 'react';
import { Controller } from 'react-hook-form';
import { FormControl, Input, FormLabel, FormErrorMessage, useColorModeValue, Text, Flex } from '@chakra-ui/react';

const InputField = forwardRef(
   (
      {
         name,
         control,
         register,
         label,
         type = 'text',
         isDisabled = false,
         required = false,
         value,
         onChange,
         onKeyDown,
         errors = {},
         errorName,
         ...props
      },
      ref,
   ) => {
      const [isFocused, setIsFocused] = useState(false);
      const textColor = useColorModeValue('gray.800', 'white');
      const valueColor = useColorModeValue('#000000', 'white');
      const labelbg = useColorModeValue('white', '#2F394A');
      const [parent, child] = name.split('.');
      const isFloating = !!(value !== '' && value !== null && value !== undefined);
      const isDateType = type === 'date';
      const isvalide = value !== '' && value !== null && value !== undefined;
      return (
         <FormControl
            position="relative"
            // isInvalid={errors[parent]?.[child] !== undefined}
            isInvalid={errors[errorName]}>
            <Input
               ref={ref}
               id={name}
               value={value}
               onChange={onChange}
               onKeyDown={onKeyDown}
               name={name}
               placeholder=" "
               type={type}
               isDisabled={isDisabled}
               onFocus={() => setIsFocused(true)}
               onBlur={() => setIsFocused(false)}
               borderRadius="md"
               borderColor="gray.300"
               paddingTop={1}
               paddingBottom="0.25rem"
               color={valueColor}
               {...props}
            />
            {label ? (
               <FormLabel
                  htmlFor={name}
                  position="absolute"
                  top={isFocused || isFloating || isDateType || isvalide ? '-8px' : '8px'}
                  left="0.75rem"
                  fontSize={isFocused || isFloating || isvalide ? 'xs' : 'md'}
                  color={textColor}
                  pointerEvents="none"
                  backgroundColor={labelbg}
                  bg={labelbg}
                  px="1"
                  zIndex={1}
                  transition="all 0.2s ease-in-out">
                  <Flex>
                     {label}
                     {required ? (
                        <Text color="red.500" ml={1}>
                           *
                        </Text>
                     ) : null}
                  </Flex>
               </FormLabel>
            ) : null}
            {errors[errorName] ? <FormErrorMessage>{errors[errorName]}</FormErrorMessage> : null}
         </FormControl>
      );
   },
);

export default InputField;
